import script from "./MembershipHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./MembershipHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./MembershipHistoryView.vue?vue&type=style&index=0&id=16ad36b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16ad36b3"]])

export default __exports__